(function ($) {
  $(() => {
    if ($(window).width() < 1200) {
      return;
    }

    window.onload = function () {
      lax.init();

      lax.addDriver("scrollY", () => window.scrollY);

      // Add animation bindings to elements
      lax.addElements(".js-image-text-title-first", {
        scrollY: {
          translateX: [
            ["elInX", "elCenterX", "elOutX"],
            {
              1199: [0, 0, 250],
              300: [0, 0, 0],
            },
          ],
        },
      });

      lax.addElements(".js-image-text-title-first-sus", {
        scrollY: {
            translateX: [
                ["elInY", "elOutY"], // Driver value map
                [0, 150],
              ],
        },
      });

      lax.addElements(".js-image-text-title-second", {
        scrollY: {
          translateX: [
            ["elInX", "elCenterX", "elOutX"],
            {
              1199: [1000, 150, 0],
              300: [0, 0, 0],
            },
          ],
        },
      });

      lax.addElements(".js-projects-title", {
        scrollY: {
          translateX: [
            ["elInY", "elOutY"], // Driver value map
            [0, 150],
          ],
        },
      });

      lax.addElements(".js-results-title", {
        scrollY: {
          translateX: [
            ["elInX", "elCenterX", "elOutX"],
            {
              1199: [-100, -300, 150],
              300: [0, 0, 0],
            },
          ],
        },
      });
    };
  });
})(jQuery);
